module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "bloco-animacao-redirecionar-usuario"
  }, [_c('h1', [_c('BreedingRhombusSpinner')], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-187255fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginLogout/LoginTokenTemporario.vue
// module id = 958
// module chunks = 1